var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.998 0.71048H2.2168C1.05369 0.71048 0.107422 1.65675 0.107422 2.81985V8.06985C0.107422 9.23296 1.05369 10.1792 2.2168 10.1792H15.998C17.1612 10.1792 18.1074 9.23296 18.1074 8.06985V2.81985C18.1074 1.65675 17.1612 0.71048 15.998 0.71048ZM16.7012 8.06985C16.7012 8.45756 16.3857 8.77298 15.998 8.77298H2.2168C1.82909 8.77298 1.51367 8.45756 1.51367 8.06985V2.81985C1.51367 2.43215 1.82909 2.11673 2.2168 2.11673H15.998C16.3857 2.11673 16.7012 2.43215 16.7012 2.81985V8.06985Z",
    fill: "#677C95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93066 4.74167H8.44866C8.83699 4.74167 9.15178 5.05647 9.15178 5.44479C9.15178 5.83312 8.83698 6.14792 8.44866 6.14792H3.93066C3.54234 6.14792 3.22754 5.83312 3.22754 5.44479C3.22754 5.05647 3.54234 4.74167 3.93066 4.74167Z",
    fill: "#677C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInput);
export default __webpack_public_path__ + "static/media/input.ae1fde1619b6ee302ba309b598b52a5f.svg";
export { ForwardRef as ReactComponent };